<template>
  <div v-if="topics" class="topics-list">
    <div class="row mt-4">
      <b-input-group class="col-md-3">
        <b-form-input id="topic-filter" :placeholder="$_t('KW:filterTopic')" v-model="filter"></b-form-input>
        <b-input-group-text :slot="isRTL ? 'prepend' : 'append'">
          <i class="fa fa-search"></i>
        </b-input-group-text>
      </b-input-group>
      <div class="col-md-3">
        <v-select
          :placeholder="$_t('KW:filterByTopicCategory')"
          :options="topicCategories"
          v-model="topicCategory"
          @input="filterTopicsByCategory"
          class="h-100"
          label="name"
        ></v-select>
      </div>
    </div>
    <div class="mt-4">
      <router-link to="/masechtos" class="font-weight-bold" style="font-size: 1.1rem">
        <span class="fa fa-external-link"></span>
        <span>{{ $_t('KW:site.titleWithSubtitle') }}</span>
      </router-link>
    </div>
    <ul class="list-unstyled pt-md-2 pt-4" v-if="filteredTopics.length > 0">
      <li v-for="topic in filteredTopics" :key="topic.id" :class="topic.children ? 'has-children' : ''" class="pb-md-2 pb-4">
        <span v-b-toggle="topic.url_key" @click="expanded = topic.url_key">
          <i class="when-opened fa fa-minus-square"></i>
          <i class="when-closed fa fa-plus-square"></i>
          {{ topic.name }} ({{ topic.shiurim_count ? topic.shiurim_count : 0 }})
        </span>
        <router-link :to="{ name: 'topic', params: { parenttopic: topic.url_key } }" class="link fa fa-external-link ml-2"></router-link>
        <b-collapse :id="topic.url_key" v-if="topic.children" :visible="isVisible(topic.url_key)">
          <ul class="list-unstyled topic-children pl-3 pt-md-2 pt-4">
            <li v-for="child in topic.children" :key="child.id" class="pb-md-2 pb-4">
              <router-link
                :to="{
                  name: 'topic',
                  params: { parenttopic: topic.url_key, topic: child.url_key },
                }"
                >{{ child.name }} ({{ child.shiurim_count }})</router-link
              >
            </li>
          </ul>
        </b-collapse>
      </li>
    </ul>
    <h3 v-else class="pt-3 text-center">
      {{ $_t('KW:noTopicsMatch', { query: filter }) }}
    </h3>
  </div>
</template>
<script>
import VueSelect from 'vue-select';

export default {
  components: {
    vSelect: VueSelect,
  },
  props: ['topicCategory', 'topicCategories', 'topicCategoryUrl'],
  data: function () {
    return {
      topics: null,
      loading: false,
      filter: '',
      expanded: null,
    };
  },
  mounted: function () {
    this.getData();
  },
  computed: {
    filteredTopics: function () {
      let allTopics = this.topics;

      if (this.topicCategoryUrl && this.topicCategoryUrl !== 'all') {
        allTopics = allTopics.filter(t => t.category).filter(t => t.category.url_key === this.topicCategoryUrl);
      }

      if (this.filter == '') {
        return allTopics;
      }
      var searchRegex = new RegExp(this.filter, 'i');
      var searchedArray = [];
      var topics = JSON.parse(JSON.stringify(allTopics));
      topics.forEach(function (value) {
        if (searchRegex.test(value.name)) {
          searchedArray.push(value);
        } else {
          var tmpFilter = value.children.filter(function (child) {
            return searchRegex.test(child.name);
          });
          if (tmpFilter.length > 0) {
            var tmp = value;
            tmp.children = tmpFilter;
            searchedArray.push(tmp);
          }
        }
      });
      return searchedArray;
    },
  },
  methods: {
    isVisible: function (url_key) {
      if (this.filter.length >= 3) {
        return true;
      }
      if (this.expanded == url_key) {
        return true;
      }
      return false;
    },
    getData: function () {
      this.topics = null;
      this.loading = true;
      this.$http.get('/api/topics').then(response => {
        this.topics = response.data;
        this.loading = false;
      });
    },
    filterTopicsByCategory() {
      this.topicCategoryUrl = this.topicCategory ? this.topicCategory.url_key : null;
    },
  },
};
</script>
<style lang="scss">
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
.has-children .link {
  display: none;
}
.topics-list ul > li {
  font-weight: 700;
  font-size: 1.1rem;
}
.topics-list ul > li > ul {
  font-weight: 400;
}
.has-children:hover .link {
  display: inline-block;
}

.topics-list {
  input#topic-filter {
    border-radius: 10px 0 0 10px;
    height: 40px;
    border-right: none;
  }
  .input-group-text {
    border-radius: 0 10px 10px 0;
    background: transparent;
    border-left: none;
    .fa {
      color: $secondary;
      font-weight: bold;
      font-size: 1rem;
    }
  }

  ul > li {
    // width: 50%;
    // display: inline-block;
  }
}
</style>
